export default __webpack_public_path__ + "static/media/arrow-right.1663b4fc.svg";